import './css/styles.css';

import API                                      from './lib/iprs-api-library/src/api/API.js';
import { getURLSearchParam, decodeJWT  }        from './utils';
import { useState, useEffect }     from 'react';
import FormWrapper from './components/FormWrapper';
import PaymentMessage from './components/PaymentMessage';

const apiURL = process.env.REACT_APP_IPRS_WEB_API_URL;
const api = new API(null,apiURL);

const App = () => {

    const [err, setErr] = useState('');

    useEffect(()=>{
        const token = getURLSearchParam('Token');
        api.validateLoggedIn(token)
            .then( token => {
                console.log('token', token);
                const decodedToken = decodeJWT(token);
                console.log('decodedToken', decodedToken);
            }).catch(e => setErr( e.apiText));
    }, []);

    return (
        <>
            <div className="App">
                <div className="container">
                    <header className="topHeader main__top">
                        <div className="main__top-logo">
                            {/* 
                            Image file here is located in public/images directory
                        */}
                            <img
                                src="images/iprshealth.svg"
                                alt="IPRS Health"
                            />
                        </div>
                    </header>

                    <div className="header__supplementary"></div>

                    <div className="typography">
                        <main className="Main__section">
                            <br />
                            <br />
                            {/* Error Message */}
                            {/* {console.log('error:', err ? err : 'none')} */}
                            {err ? <p>Application Error: {err}</p> : <></>}

                            {/* Payment Message */}
                            <PaymentMessage />

                            <section className="main__section">
                                <FormWrapper api={api} />
                            </section>
                        </main>
                    </div>
                </div>

                <footer className="footer">
                    <div className="footer__content group">
                        <div className="container">
                            <div className="footer__left">
                                <p>Part of</p>
                                <a
                                    href="http://www.iprsgroup.com/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="footer__logo replace"
                                >
                                    IPRS Group
                                </a>
                            </div>
                            <div className="footer__right">
                                <p>
                                    <a
                                        href="https://www.iprshealth.com/cookie-policy/"
                                        rel="noreferrer"
                                        target="_blank"
                                    >
                                        Privacy &amp; Cookies
                                    </a>
                                </p>
                                <br />
                                <br />
                                <br />
                                <p>
                                    <small>
                                        &copy; 2019-2025 IPRS Health Limited,
                                        Speed Medical House, Chorley, Lancashire
                                        PR7 1NA. Registered in England and Wales
                                        (03015659)
                                    </small>
                                </p>
                                <p>
                                    <small>
                                        Website design:{" "}
                                        <a
                                            href="http://www.nakedmarketing.co.uk/"
                                            rel="noreferrer"
                                            target="_blank"
                                        >
                                            Naked Marketing
                                        </a>
                                    </small>
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default App;

